import React from "react";
import { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import Timer from "./TheTimer";
import GUI_Header from "./gui/GUI_Header";
import GUI_Credit from "./gui/GUI_Credit";
import GUI_InputTextArea_withClearClick from "./gui/GUI_InputTextArea_withClearClick";
import GUI_InputTextSingle from "./gui/GUI_InputTextSingle";
import Template from "./TheTemplate";
import T from "./TheTool";

//https://www.pluralsight.com/guides/how-to-pass-data-between-react-components

const WordBreak = () => {
	const pageTitle =
		"Word Break Problem - determine if the string can be segmented";
	const title = "Word Break Problem";
	const desc =
		"Given a string and a dictionary of words, determine if the string can be segmented into a space-separated sequence of one or more dictionary words.";

	useEffect(() => {
		document.title = pageTitle;
	}, []);
	const [guiTxt1, guiTxtChange1] = useState("samsungandmango"); //bag size
	const [guiTxtArea, guiTxtAreaChange] = useState(
		"and\ng\ngo\ngun\ngrand\nsamsung\nsam\nsun\nman\nmango\nmantis\nmobile"
	);
	const [partResult, partResultChange] = useState(<div></div>); //bottom part that show result
	const childRef = useRef(null); //Result component at bottom
	//---------------------------------------------
	var txt_time = ""; //processing time
	var str = "";
	var dict; //[];
	var arr_output; //[]

	//Main Function
	const buttonClick1 = () => {
		str = guiTxt1;
		dict = guiTxtArea.split("\n");
		arr_output = [];
		// console.log("DICT " + dict);
		process();
	};

	function process() {
		Timer.start();
		wordBreak(str, "");
		txt_time = Timer.stop_print();
		BuildResult();
	}

	function wordBreak(word, out) {
		// if the end of the string is reached, print the output string
		if (word.length == 0) {
			console.log("OUTPUT " + out);
			arr_output.push(out);
			return;
		}
		for (var i = 1; i <= word.length; i++) {
			// consider all prefixes of the current string
			var prefix = T.substring(word, 0, i);
			// if the prefix is present in the dictionary, add it to the output string and recur for the remaining string
			if (dict.includes(prefix)) {
				// console.log("TTT " + T.substring_from(word,i));
				wordBreak(T.substring_from(word, i), out + " " + prefix);
			}
		}
	}

	function BuildResult() {
		var txt1;
		if (arr_output.length > 0) {
			txt1 = arr_output.join("\n");
			txt1 += str;
		} else {
			txt1 = "Cannot be segmented";
		}
		var txt2 = ""; //txt_result + " is the LCS, or one of them.";
		txt_time = "\n" + txt_time;
		var part1 = Template.simple4size(
			"key2",
			"Result",
			txt2,
			txt1,
			txt_time,
			28,
			24,
			20,
			16
		);
		partResultChange(<div>{part1}</div>);
	}

	return (
		<div className="todoapp stack-large">
			<GUI_Header title={title} desc={desc} />
			<div style={{ marginTop: "3em" }}> </div>
			<GUI_InputTextSingle
				text1Change={guiTxtChange1}
				label={""}
				text1={guiTxt1}
				numberOnly={false}
				width1={0}
				width2={"100%"}
				fontSize2={20}
				placeholder={"string"}
			/>
			<div style={{ marginTop: "2em" }}> </div>
			<GUI_InputTextArea_withClearClick
				guiTxtArea={guiTxtArea}
				guiTxtAreaChange={guiTxtAreaChange}
				buttonClick={buttonClick1}
				label1={"Dictionary of Words"}
			/>
			<div style={{ marginTop: "3em" }}> </div>
			{partResult}
			<GUI_Credit />
		</div>
	);
};

export default WordBreak;
